module.exports = __webpack_public_path__ + "img/tuition.af892d80.jpg";